import { httpRequest } from "@services/http";
import type { OrgUser } from "./cmdListOrgUsers";

export class CommandSetUserActive {
  async run(orgId: number, profileId: number, isActive: boolean): Promise<OrgUser> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/permissions/organizations/${orgId}/users/${profileId}/status`;
    try {
      return await httpRequest<OrgUser>(url, {
        method: "PUT",
        body: { is_active: isActive },
      });
    } catch (error) {
      console.error("Error setting user active state:", error);
      throw error;
    }
  }
}
